import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import LocationPage from "./pages/LocationPage";
import FoodMenuPage from "./pages/FoodMenuPage";
import ExpressPage from "./pages/ExpressPage";
import PromotionsPage from "./pages/PromotionsPage";
import AboutPage from "./pages/AboutPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/location/:city" element={<LocationPage />} />
            <Route path="/food-menu" element={<FoodMenuPage />} />
            <Route path="/menu" element={<Navigate to="/food-menu" replace />} />
            <Route path="/express" element={<ExpressPage />} />
            <Route path="/promotions" element={<PromotionsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;